import styled from 'styled-components';
import { spacing } from '@naf/theme';

export const ReadMoreWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.space8};
  max-width: 1125px;
`;
